var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 -1.5299e-06C27.1564 -6.85708e-07 35 7.84359 35 17.5C35 27.1564 27.1564 35 17.5 35C7.84359 35 6.85708e-07 27.1564 1.5299e-06 17.5C2.37409e-06 7.84359 7.84359 -2.37409e-06 17.5 -1.5299e-06ZM17.5 33.2051C26.1692 33.2051 33.2051 26.1692 33.2051 17.5C33.2051 8.83077 26.1692 1.79487 17.5 1.79487C8.83077 1.79487 1.79487 8.83077 1.79487 17.5C1.79487 26.1692 8.83077 33.2051 17.5 33.2051Z",
    fill: "#30313A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 8.77696L27.9281 20.4257C28.2512 20.8026 28.2332 21.359 27.8563 21.7C27.4973 22.0231 26.923 22.0052 26.5819 21.6282L17.4819 11.4693L8.27423 21.6462C7.93321 22.0052 7.3768 22.0411 6.99987 21.718C6.6409 21.377 6.605 20.8206 6.92808 20.4436L17.464 8.79491L17.4999 8.77696Z",
    fill: "#30313A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(35 35) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.4057a0eddc847e1000b6465c1999fd14.svg";
export { ForwardRef as ReactComponent };